import { Component, Inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { AdminService } from '../../services/AdminService/admin';
import { extractErrorMessage } from '../../shared/error-utils';
import { ErrorBanner } from '../../shared/components/error-banner/error-banner';

export interface TopUpDialogData {
  companyId: string;
  companyName: string;
}

@Component({
  selector: 'app-top-up-dialog',
  imports: [
    CommonModule,
    FormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    ErrorBanner,
  ],
  templateUrl: './top-up-dialog.html',
  styleUrl: './top-up-dialog.scss',
})
export class TopUpDialog {
  amount: number | null = null;
  note = '';

  isSubmitting = signal(false);
  errorMessage = signal('');

  constructor(
    private dialogRef: MatDialogRef<TopUpDialog>,
    private admin: AdminService,
    @Inject(MAT_DIALOG_DATA) public data: TopUpDialogData
  ) {}

  get canSubmit(): boolean {
    return !!this.amount && this.amount > 0;
  }

  cancel(): void {
    this.dialogRef.close();
  }

  submit(): void {
    if (!this.canSubmit || !this.amount) {
      return;
    }

    this.isSubmitting.set(true);
    this.errorMessage.set('');

    this.admin.topUpWallet(this.data.companyId, { amount: this.amount, note: this.note || undefined }).subscribe({
      next: () => {
        this.isSubmitting.set(false);
        this.dialogRef.close(true);
      },
      error: (err: HttpErrorResponse) => {
        this.isSubmitting.set(false);
        this.errorMessage.set(extractErrorMessage(err, 'Failed to top up wallet.'));
      },
    });
  }
}
